import { Component, Fragment } from 'react';
import RsvpItem from '~/js/components/general/rsvp-now/RsvpItem';
// import testData from '~/js/components/general/rsvp-now/data/nights';
import Select from '~/js/components/general/Select';
import Spinner from '~/js/components/general/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper';
// import modal from '~/js/modules/magnific-popup';

/* eslint-disable */

const fetch = new GoFetch();

const internals = {
  usaStates: window.beaches_app.page.states.filter((el) => el.countryId === 210),
};

const nightsData = window.beaches_app.page.nightsData;

class RsvpNow extends Component {
  state = {
    stateChecked: {}
  }

  componentDidUpdate = () => {
    // modal();
  }

  getData = () => {
    const { stateChecked } = this.state;
    const selectedState = Object.values(stateChecked)[0];
    const data = {
      stateCode: selectedState.code
    };

    // testData.forEach(function (value) {
    //   console.log(value.state);
    // });

    this.setState({ isLoading: true });

    let beachesNights = [];

    if (typeof nightsData[selectedState.code] !== 'undefined') {
      beachesNights = nightsData[selectedState.code];
    }
    else {
      beachesNights = [];
    }
    // const { beachesNights } = { "beachesNights": [{ "nightId": 18618, "time": "7:30pm,", "address": "https://bit.ly/2Ds5vDP", "city": "Fort Lauderdale", "state": "FL", "email": "amydeppe@travelmation.net", "infoName": "Amy Deppe", "infoNumber": "410-458-6621", "Agency": "Travelmation ", "date": "2018-11-28", "zipCode": "33304" }] };

    this.setState({ nightsData: beachesNights, isLoading: false });

    // fetch.post('/getBeachesNightsByState/', null, data)
    //   .then((response) => {
    //     const { beachesNights } = response.data;

    //     this.setState({ nightsData: beachesNights, isLoading: false });
    //   });
  }


  onChange = (item) => {
    this.setState({
      stateChecked: { [item.id]: item }
    }, this.getData);
  }

  clear = () => {
    const $main = $('html, body');
    const $selectTop = $('.caribbean-nights-select').offset().top;

    this.setState({
      stateChecked: {},
      nightsData: null
    });

    $main.animate({
      scrollTop: $selectTop - 34
    }, 600);
  }

  render() {
    const { stateChecked, nightsData, isLoading } = this.state;
    const { usaStates } = internals;



    const selectedState = Object.values(stateChecked)[0];

    let findLocation;
    let nights = <Spinner />;

    if (nightsData && !isLoading) {
      if (nightsData.length > 0) {
        nights = (
          <div className="row">
            {nightsData.map((el, index) => (
              <RsvpItem
                key={index}
                data={el}
                className="xs-12 xl-6" />
            ))}
          </div>
        );
      } else {
        nights = (
          <div className="caribbean-nights-nodata-content">
            <h2 className="caribbean-nights-nodata-content-title">
              There is currently no upcoming VIP Experience in your state. However, we will connect you to a local Preferred Beaches Specialist who will assist you in planning your Luxury Included<sup>&reg;</sup> Vacation at one our resorts.
            </h2>
          </div>
        );
      }
    }

    if (selectedState) {
      findLocation = (
        <section className="caribbean-nights-data-wrap container">
          <div className="caribbean-nights-data">
            <h2 className="caribbean-nights-data-title">
              VIP Experience Locations in: <span className="colored">{selectedState.name}</span>
            </h2>
            <p className="caribbean-nights-data-text">Please note that RSVP&#8217;s for VIP Experience can only be submitted to the selected travel agency. Beaches Resorts does not coordinate RSVP&#8217;s for VIP Experience.</p>

            {nights}
          </div>
          <div className="caribbean-nights-find-location">
            <h2 className="caribbean-nights-find-location-title">
              Can&#8217;t find a convenient location?
            </h2>
            <button
              className="caribbean-nights-find-location-link"
              onClick={this.clear}>
              FIND A NEW LOCATION
            </button>
          </div>
        </section>
      );
    }

    return (
      <Fragment>
        <section className="caribbean-nights-select-wrap container">
          <div className="caribbean-nights-select">
            <div className="caribbean-nights-select-title-1">
              <span className="colored">Locate a VIP Experience Near You</span>
              <img src="//cdn.sandals.com/sandals/v12/images/general/caribbean-nights/usa-flag.jpg" alt="USA flag" />
            </div>
            <div className="caribbean-nights-select-box">
              <Select
                data={usaStates}
                labelKey="name"
                markedKey="id"
                checked={stateChecked}
                placeholder="Select a State"
                onChange={this.onChange} />
            </div>
          </div>
        </section>

        {findLocation}
      </Fragment>
    );
  }
}

export default RsvpNow;
